/*
* Author: Boris Kotlyarov
* */

const log = console.log;

class LoadMore {

    constructor(){
        this.api = {
            url: '/wp-json/themehelper/posts'
        };

        this.moreContainer = document.querySelector('[data-selector="more-container"]');
        this.moreLink = document.querySelector('[data-selector="load-more"]');

        if(this.moreLink){ this.listen(); }

    }

    listen(){
        this.moreLink.addEventListener('click', ()=>{
            this.request().then((response)=>{
                if(response.length==0 || response.length != parseInt(this.moreLink.dataset.limit)) {
                    this.moreLink.remove();
                }
                let lastChild = this.moreContainer.lastElementChild;
                let scrollEl = ($(lastChild).offset().top)+lastChild.offsetHeight;

                response.forEach((item)=>{ this.moreContainer.innerHTML += item;});

                $('html,body').animate({ scrollTop: scrollEl }, 1000);

            });
        });
    }

    request(){

        let query = [
            'per_page='+this.moreLink.dataset.limit,
            'page='+this.moreLink.dataset.page,
        ];

        let text = this.moreLink.innerText;
        let loading = document.createElement('div');
        loading.setAttribute('class', 'loading');

        $(this.moreLink).html(loading);

        return new Promise((resolve, reject)=>{
            $.get( `${this.api.url}?${query.join('&')}`)
                .done((data) => {
                    this.moreLink.dataset.page = parseInt(this.moreLink.dataset.page)+1;
                    resolve(data);
                })
                .fail(() => {
                    reject();
                })
                .always(() => {
                    this.moreLink.innerHTML = text;
                });
        });
    }

}